<template>
  <v-dialog v-model="shown" transition="fade-transition" width="500">
    <v-card>
      <v-card-title primary-title>
        <span>
          <template>Confirm</template>
        </span>
      </v-card-title>
      <v-card-text class="body-1 py-3">
        <div class="text-center">
          <template>Are you sure that you want to delete your game account?</template>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close">Go back</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="handleDelete">Yes, I'm sure</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ModalHelperMixin from '@/mixins/modal-helper';

export default {
  data() {
    return {
      data: [],
    };
  },
  methods: {
    show(data) {
      this.shown = true;
      this.data = data;
    },
    handleDelete() {
      this.$emit('delete', this.data);
      this.close();
    },
  },
  mixins: [ModalHelperMixin],
};
</script>
